import v13Schema, {
  MigrationTypes as V13Types,
} from "../client/schemaVersions/v13.js";
import v14Schema, {
  MigrationTypes as V14Types,
} from "../client/schemaVersions/v14.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V13Types, V14Types>(
  v13Schema,
  v14Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
